<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Cotizaciones de Dólar</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12 justify-content-center">
          <card class="mb-4" :no-body="true" header-classes="pb-3">
            <!-- Card header -->
            <template slot="header">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Cotización por defecto</h3>
                  <small> El tipo de cotización seleccionado sera el utilizado por defecto para los pedidos </small>
                </div>

                <el-select v-model="typeSelected" cy-id="dollar-select" class="col select-primary">
                  <el-option
                    v-for="dollarType in dollarOptions"
                    :key="dollarType.value"
                    :label="dollarType.label"
                    :value="dollarType.value"
                    cy-id="dollar-option"
                    class="select-primary"
                  />
                </el-select>

                <div class="col text-right">
                  <base-button cy-id="save-dollar" native-type="submit" type="primary" @click="updateDefaultType">
                    Guardar
                  </base-button>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <dollar-quotations-table />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';

import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import DollarQuotationsTable from './List/DollarQuotationsTable';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DollarQuotationList',
  components: {
    DollarQuotationsTable,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      types: [],
      typeSelected: '',
    };
  },

  computed: {
    ...mapGetters('config', ['dollarSelected', 'dollarOptions']),
  },

  watch: {
    dollarSelected: {
      immediate: true,
      handler() {
        this.typeSelected = this.dollarSelected;
      },
    },
  },

  methods: {
    ...mapActions('config', ['updateDollarConfig']),

    updateDefaultType() {
      this.updateDollarConfig(this.typeSelected);
    },
  },
};
</script>
